import { z } from "zod";

export const vesselFormSchema = z.object({
  name: z.string().min(1, "required"),
  description: z.string().min(1, "required"),
  imoNumber: z.string().min(1, "required"),
  mmsi: z.string().min(1, "required"),
  vesselType: z.string().min(1, "required"),
  affiliate: z.string().min(1, "required"),
  hireDate: z.string().min(1, "required"),
  vesselCategoryId: z.string().min(1, "required"),
});

export type vesselFormType = z.infer<typeof vesselFormSchema>;
